import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "b-event-month-card__text" }
const _hoisted_2 = {
  key: 0,
  class: "b-event-month-card__appointment"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["b-event-month-card__item", {"b-event-month-card__item__transparent": _ctx.event.origin === `from_unavailability`}])
  }, [
    _createElementVNode("div", {
      class: "b-event-month-card__label",
      style: _normalizeStyle({ background: _ctx.color })
    }, null, 4),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.event.title), 1),
    (_ctx.event.origin === `from_appointment`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true)
  ], 2))
}